import React from 'react'
import './About.css'

const About = () => {
  return (
    <div className="about-container">
      <h3>Acerca de mi</h3>
      <p>
        Descubrí hace unos años el mundo de la programación y me enamoré. A partir de ese momento, me he dedicado a aprender de manera autodidacta los fundamentos del desarrollo web. Si bien no poseo experiencia como programador, tengo vasta experiencia en trabajo en equipo, me manejo con comodidad bajo presión y estoy acostumbrado a la toma de decisiones en diversos contextos laborales.
        <br /> 
        <b>Ojalá puedan darme la oportunidad de demostrar lo que puedo brindarle a cualquier equipo de trabajo!</b>
      </p>
    </div>
  )
}

export default About

